import { render, staticRenderFns } from "./WsInfoDate.vue?vue&type=template&id=61ea04df&"
import script from "./WsInfoDate.vue?vue&type=script&lang=js&"
export * from "./WsInfoDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports